export const getShowResultsButton = () => document.querySelector<HTMLButtonElement>("#fltCont .btn-show-results")
export const getShowResultsButtonLocationModal = () =>
    document.querySelector<HTMLButtonElement>("#fltRegio .btn-show-results")
export const advertCardsContainerElement = () => document.querySelector<HTMLDivElement>("#azm-gallery")
export const getSearchTextElement = () => document.querySelector<HTMLInputElement>("#filter-freitext")
export const searchTextButtonElement = () => document.querySelector<HTMLInputElement>("#filter-freitext-button")
export const searchTextButtonIcon = () => document.querySelector<SVGElement>("#filter-freitext-button svg")
export const getOpenSearchTextButton = () => document.getElementById("open-suchtext")
